import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'normalize.css'
import '@/assets/css/base.css'
import api from './api'

Vue.prototype.$api = api;

// 注册全局组件
import Breadcrumb from './components/breadcrumb/Breadcrumb.vue'
Vue.component('Breadcrumb',Breadcrumb)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
